import { StyledRow } from '@/shared/styles';
import { StyledIssueText, StyledVerticalBorder } from '../AccessibilityIssues.styles';
import { CategoryIconsDic, SelectedIssueProps } from './AllIssues.consts';
import { useAccessibilityCheckerStore } from '@/stores/AccessibilityCheckerStore/AccessibilityCheckerStore';
import { Icon } from '@/shared/components/Icon';
import { useThemeStore } from '@/stores/ThemeStore/ThemeStore';
import { useTranslation } from 'react-i18next';
import { IssuesAmount } from './IssuesAmount';
import { U1Button } from '@u1/react-a11y-hooks';

export const AccessibilityCategory: React.FC<SelectedIssueProps> = ({
  categoryType,
}: SelectedIssueProps) => {
  const { selectedIssueCategory, selectIssueCategory, getAmountOfIssuePerCategory } =
    useAccessibilityCheckerStore();
  const isSelected = categoryType === selectedIssueCategory;
  const issuesAmount = getAmountOfIssuePerCategory(categoryType);
  const { isDarkMode } = useThemeStore();
  const { t } = useTranslation();

  const getCategoryIcon = () => {
    const selectedKey = isSelected ? 'selected' : 'unselected';
    const issuesStatusKey = issuesAmount > 0 ? 'has_issues' : 'no_issues';
    return CategoryIconsDic[issuesStatusKey][selectedKey];
  };

  return (
    <StyledRow $gap={10}>
      <StyledVerticalBorder isSelected={isSelected} />
      <Icon $src={getCategoryIcon()} $invert={!isDarkMode && !isSelected} />
      <U1Button>
        <StyledIssueText
          isSelected={isSelected}
          onClick={() => selectIssueCategory(categoryType)}
          data-u1-button="button"
        >
          <span>{t(`free_tools.accessibility_checker.category.${categoryType}`)}</span>
          <IssuesAmount issuesAmount={issuesAmount} />
        </StyledIssueText>
      </U1Button>
    </StyledRow>
  );
};
